const URL="http://54.152.206.84:8000/"
const allSymptoms = ["fever", "chills", "musclepain", "wateryeye", "runnynose", "sneezing", "sorethroat", "cough", "chestpain"]
const prettySymptoms  = ["Fever", "Chills", 'Muscle Pain', 'Watery Eye', 'Runny Nose', 'Sneezing', 'Sore Throat', 'Cough', "Chest Pain"]
const colors = ["red","aqua","orange","green","pink", "purple", "darkred", "brown", "darkblue"];

async function performSymptomFetch(myPtids) {
	

	//CHANGES SN 11/16/2022 and 11/20/2022
	//Cleaned up input data
	//Modified let statement for symptoms to forward symptom information to new modifySymptomsList function
	let myPatients = modifyPatientList(document.getElementById("inputpatient").value.toString()).split(",").map(function(str){
		return parseInt(str);});
	//let myPatients = document.getElementById("inputpatient").value.split(",");
	let symptoms = modifySymptomList(document.getElementById("inputsymptom").value).toLowerCase().split(", ");
	
	console.log("Patients " + myPatients + " symptoms " + symptoms);
	
	var myDates = [], max = 0, myDataset = [];

	//for each patient, grabs their associated scores and dates
	for (let i = 0; i < myPtids.length; i++) {
		var myPtid = myPtids[i], pat = myPatients[i]
		
		//Sending info to the backend via a fetch command
		let scoreResponse = await fetch(URL + 'list/scores/?ptid=' + myPtid)
		let scoreData = await scoreResponse.json();

		let start = 0;
		//all symptom function goes here
		if (symptoms.includes("all")) {

			//sort and set start to 1 to leave all symptoms out 
			symptoms.sort();
			start=1;
			[{ myDataset, max }] = await sumAllSymptoms(myPtid, pat, myDataset, myDates, symptoms, max);
		}  

		for (start; start < symptoms.length; start++) {
			let symptom = symptoms[start], myScores = []; 
	
			//iterate through each JSON line and push the associated symptom score and date to its array
			for (let k = 0; k < scoreData.length; k++) {
				let myScore = scoreData[k][symptom];
				let myDate = (scoreData[k].date).toString();
				
				if (myScore > max) { max = myScore } 
				myScores.push({ x:myDate, y: myScore })
				myDates.push(myDate)
			} //end of for loop for pushing data to arrays

			myDataset[myDataset.length] = {
				data: myScores,
				label: "Patient: " + myPatients[i] + " | Symptom: " + prettySymptoms[allSymptoms.indexOf(symptom)],
				backgroundColor: colors[myDataset.length],
				borderColor: colors[myDataset.length]}

		} //end of symptom

	} //end of for myPatients for loop

        var uniqueDates = myDates.filter((value, index) => {
                return myDates.indexOf(value) === index;
        });

        let myLabels = uniqueDates.sort(function(a, b){return a-b});

	finalDataset  = await sympViralInfections(myPatients, myPtids, myDataset, myLabels, max);
	return [{ myLabels, finalDataset }]; 

}//end of performFetch()

async function sumAllSymptoms(myPtid, pat, myDataset, myDates, symptoms, max) {

	let myFetch = await fetch(URL + 'list/scores/?ptid=' + myPtid)
	let myData = await myFetch.json();

	let myScores = []

	for (line in myData) {
		let myLine = (myData[line]), score = 0

		myDates.push(myLine.date)
		for (symp in allSymptoms) {
			let mySymptom = allSymptoms[symp]
			score += (myLine[mySymptom])
		}

		myScores.push({x: myLine.date, y:(score/9)})
		if (max < (score/9)) { max = (score/9) }
	}

	myDataset[myDataset.length] = {
		labels: myDates,
		data: myScores,
		label: "Patient: " + pat + " | Averaged Scores",
		backgroundColor: colors[myDataset.length],
		borderColor: colors[myDataset.length]}
	
	return [{myDataset,max}]
}

//CHANGES SN 11/20/2022
//Created new function to clean up input symptom data
function modifySymptomList(rawinput){
	var symptom = [...new Set(rawinput.replaceAll('.', ',').replace(/\s/g, '').toLowerCase().split(",").filter(n => n))];
	for (let i = 0; i < symptom.length; i++){
		symptom[i] = symptom[i].charAt(0).toUpperCase() + symptom[i].slice(1);
	}
//	symptom = symptom.map(element => {
//		return element.charAt(0).toUpperCase() + element.slice(1);
//	});
	return symptom.join(", ");
}

//CHANGES SN 11/21/2022
//Created new function to clean up input patient data
function modifyPatientList(rawinput){
	let patient = [...new Set(rawinput.replaceAll('.', ',').replace(/\s/g, '').split(",").filter(n => n))];
	return patient.join(",");
}

async function submitSymptomInfo() {
	//CHANGES SN 11/20/2022 and 11/21/2022
	//Called new functions to alter visible graph title, patient labels
	let symptom = modifySymptomList(document.getElementById("inputsymptom").value);
	let patients = modifyPatientList(document.getElementById("inputpatient").value.toString());
	
	//retrieve all scores and dates from a patient
	let myPtids = await getPtId(patients)
	let [{ myLabels, finalDataset }] = await performSymptomFetch(myPtids)
	
	let chartStatus = Chart.getChart("symptomChart");
	if (chartStatus != undefined) {
		chartStatus.destroy()
	} //end of destroying chart
	
	window.myChart = new Chart(document.getElementById("symptomChart").getContext('2d'), {
        	type: "line",
                data: { labels: myLabels, datasets: finalDataset },
		options: { responsive: true,
                	plugins: {
				title: { display: true, 
					text: "Symptom Severity Scores for " + symptom, 
					font: { size: 20, weight: 'bold'} }
			}, scales: {
				x: { title: { display: true, text: 'Days' }, stacked:true, beginAtZero: false }, 
				y: { title: { display: true, text: "Score" } } } } }); //end of chart
	
} //end of submitInfo()

async function getPtId(myIds) {
	let splitIds = myIds.split(",")
	let returnIds = []
	
	
	for (m=0; m < splitIds.length; m++) {

		//perform fetch
		let myResponse = await fetch(URL + 'list/ptids/?id=' + splitIds[m])
        let patData = await myResponse.json();
		
		returnIds.push(patData[0].ptid)
	}
	return returnIds
}

async function sympViralInfections(patients, myPtids, myDataset, myLabels, max) {

	if (max == 0) { max = 1 }
	
        //iterate through patients and log their associated virus
        for (j = 0; j < infectList.length; j++) {
                let myInfection = infectList[j]

		for (pat in patients) {
                	let patResponse = await fetch(URL + 'list/virus/?infection_type=' + myInfection + "&ptid=" + myPtids[pat])
                	let patData = await patResponse.json()

			if (patData.length > 0) {
				 
				let infectVals = new Array(myLabels.length).fill('0'), activeInfection = false
				
				patData.sort(function(a, b){
					let date_a = parseInt(a.date_collected), date_b = parseInt(b.date_collected);
        				return date_a - date_b});
			
				//iterate through and grab for our patients, start index at 1 to leave out None infection
				for (i = 0; i < patData.length; i++) {
					activeInfection = true
					let myDay = (patData[i].date_collected).toString()
					infectVals.splice(myLabels.indexOf((myDay)), 1, max)
					
				} //end of i in finalData

				let len = myDataset.length
                                let currentColor  = getColors(myInfection)
				
				//if there's an infection, fill out the dataset with the information
				if (activeInfection) {
					myDataset[len] = {
					data: infectVals,
					barThickness: 15,
					labels: myLabels,
					label: myInfection + " | Patient " + patients[pat],
					backgroundColor: currentColor,
					borderColor: currentColor,
					type: "bar"}
				} //end of myDataset
			} //end of dataLen > 0
		} //end of for pat in patients
        } //end of infect in infectList

	return myDataset;
}

function getColors(myInfection) {
	const infectList = ["Bocavirus", 'Bocavirus_WUPolyomavirus', 'Coronavirus 229E', 'Coronavirus 229E_Coronavirus OC43', 'Coronavirus 229E_Rhinovirus', 'Coronavirus HKU1', 'Coronavirus NL63', 'Coronavirus NL63_Respiratory syncytial virus B', 'Coronavirus OC43', 'Coronavirus OC43_Rhinovirus', 'Coronavirus OC43_WUPolyomavirus', 'Coronavirus OC43_Adenovirus_WUPoliomavirus', 'Coronavirus OC43_Rhinovirus', 'Coxackievirus', 'Enterovirus', 'Influenza A', 'Influenza A_Rhinovirus', 'Influenza B', 'Influenza C', 'Parainfluenza 2', 'Parainfluenza 4', 'RSVB_RhinovirusC_CoronavirusHKU1_ADC_WUPolyomavirus', 'Respiratory syncytial virus', 'Respiratory syncytial virus A', 'Respiratory syncytial virus B', 'Rhinovirus', 'Rhinovirus_Coronavirus OC43', 'Rhinovirus_Coronavirus229E'];
	const infectColor=['#000000','#c0c0c0','#2f4f4f','#556b2f','#8b4513','#6b8e23','#7f0000','#483d8b','#008000','#3cb371','#008080','#4682b4','#d2691e','#9acd32','#cd5c5c','#00008b','#32cd32','#daa520','#7f007f','#8fbc8f','#b03060','#d2b48c','#ff0000','#00ced1','#ff8c00','#ffd700','#6a5acd','#ffff00','#00ff00','#9400d3','#ba55d3','#00fa9a','#dc143c','#00bfff','#f4a460','#0000ff','#adff2f','#ff6347','#ff00ff','#f0e68c','#6495ed','#dda0dd','#ff1493','#afeeee','#98fb98','#7fffd4','#ff69b4','#fff8dc','#ffb6c1'];

    let index = infectList.indexOf(myInfection)
	let myPattern = index % infectList.length;
    return pattern.draw(myPatterns[myPattern], infectColor[index]);
}
